import React from 'react'
import { connect } from 'react-redux'
import EcommerceProductActions from '../../Redux/EcommerceProductRedux'
import Select from 'react-select'
import SizeActions from '../../Redux/SizeRedux'
import ColourActions from '../../Redux/ColourRedux'
import WarehouseActions from '../../Redux/WarehouseRedux'

class UpdateEcommerceProduct extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      ecommerceProductID: props.detail.id,
      inventoryID: props.inventoryID,
      selectedSize: props.selectedSize,
      selectedColour: props.selectedColour,
      selectedWarehouse: props.selectedWarehouse,
      form: {
        sku_v: props.detail.sku_v || '',
        varian_size_id: props.detail.varian_size.id || '',
        varian_colour_id: props.detail.varian_colour.id || '',
        price: props.detail.price || 0,
        buy_price: props.detail.buy_price || 0,
        warehouse_id: props.detail.warehouse.id || '',
        vm_product_id: props.detail.vm_product_id || ''
      }
    }
  }

  componentDidMount = () => {
    this.props.getSize()
    this.props.getColour()
    this.props.getWarehouse()
  }

  _inputChange = (event, field) => {
    let form = { ...this.state.form }
    let val = event.target.value
    form[field] = val
    this.setState({ form })
  }

  _selectChange = (event, field) => {
    let form = { ...this.state.form }
    form[field] = event.value
    if (field === 'varian_size_id') {
      this.setState({ selectedSize: event, form })
    } else if (field === 'varian_colour_id') {
      this.setState({ selectedColour: event, form })
    } else if (field === 'warehouse_id') {
      this.setState({ selectedWarehouse: event, form })
    }
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    const data = {
      inventoryID: this.state.inventoryID,
      ecommerceProductID: this.state.ecommerceProductID,
      form
    }
    this.props.updateEcommerceProduct(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    const { colour, size, warehouse } = this.props

    let colourPicker = []
    let sizePicker = []
    let warehousePicker = []

    colour.dataAll.map((item, i) => {
      colourPicker[i] = {
        value: item.id,
        label: item.name
      }
      return colourPicker
    })

    size.dataAll.map((item, i) => {
      sizePicker[i] = {
        value: item.id,
        label: item.name
      }
      return sizePicker
    })

    warehouse.data.map((item, i) => {
      warehousePicker[i] = {
        value: item.id,
        label: item.name
      }
      return warehousePicker
    })

    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Edit Product Variant</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Edit SKU Variant</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                className='form-control'
                value={this.state.form.sku_v}
                onChange={(event) => this._inputChange(event, 'sku_v')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Type</label>
            </div>
            <div className='col-9'>
              <Select
                options={colourPicker}
                value={this.state.selectedColour}
                required
                placeholder='Pick available type'
                onChange={(selectedColour) => this._selectChange(selectedColour, 'varian_colour_id')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Subtype</label>
            </div>
            <div className='col-9'>
              <Select
                options={sizePicker}
                value={this.state.selectedSize}
                required
                placeholder='Pick available subtype'
                onChange={(selectedSize) => this._selectChange(selectedSize, 'varian_size_id')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Vending Machine ID</label>
            </div>
            <div className='col-9'>
              <input
                type='number'
                className='form-control'
                value={this.state.form.vm_product_id}
                onChange={(event) => this._inputChange(event, 'vm_product_id')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Price</label>
            </div>
            <div className='col-9'>
              <input
                required
                type='number'
                min='0'
                value={this.state.form.price}
                onChange={(event) => this._inputChange(event, 'price')}
                className='form-control'
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Buy Price</label>
            </div>
            <div className='col-9'>
              <input
                type='number'
                min='0'
                value={this.state.form.buy_price}
                onChange={(event) => this._inputChange(event, 'buy_price')}
                className='form-control'
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Warehouse</label>
            </div>
            <div className='col-9'>
              <Select
                options={warehousePicker}
                value={this.state.selectedWarehouse}
                required
                onChange={(selectedWarehouse) => this._selectChange(selectedWarehouse, 'warehouse_id')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  size: state.size,
  colour: state.colour,
  warehouse: state.warehouse
})

const dispatchToProps = (dispatch) => ({
  getSize: () => dispatch(SizeActions.getAllSizeRequest()),
  getColour: () => dispatch(ColourActions.getAllColourRequest()),
  getWarehouse: () => dispatch(WarehouseActions.getWarehouseRequest()),
  updateEcommerceProduct: (data) => dispatch(EcommerceProductActions.updateEcommerceProductRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateEcommerceProduct)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/UpdateEcommerceProduct.js